import Repository from "./Repository";

const subscriptions = "/subscriptions";

export default {
  subscribe: (subscribeData) =>
    Repository.post(`${subscriptions}/`, subscribeData),
  hideReminder: (subscriptionId) =>
    Repository.patch(`${subscriptions}/${subscriptionId}/hide_reminder/`),
};
